import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router/index'
import Config from '@/config/config'
import util from '@/config/util'
import wxShare from '@/config/wxshare'

import './router/permission'
import "./style/style.less"

Vue.config.productionTip = false
Vue.prototype.config = Config
Vue.prototype.util = util
Vue.prototype.wxShare = wxShare
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.use(VueAxios, axios)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
